import React from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { useApplicationContext, useFeatureToggle } from '@css-xp/base';
import {
  // useFetchTransactionAccountQuery,
  useFetchProductsForTransactionAccountQuery,
  useFetchAggregatedShipToPartiesForTxa,
  useFetchInvoicesForTransactionAccountPPCQuery,
  useFetchNativeProductsForCatalogue,
} from '@css-xp/ppc-api';
import { STATSIG_FEATURE_GATES } from '@css-xp/ppc-constants';

export const CacheApiCalls = () => {
  const userProfile = useApplicationContext();
  const [txaId] = useLocalStorage(`${userProfile?.atlassianAccountId}-selectedTxa`, '');
  // useFetchTransactionAccountQuery({ txaId });
  useFetchProductsForTransactionAccountQuery({
    txaId,
    skipOption: !txaId,
  });
  useFetchAggregatedShipToPartiesForTxa({ txaId });
  useFetchInvoicesForTransactionAccountPPCQuery({ txaId });
  useFetchNativeProductsForCatalogue();

  return null;
};

export const GlobalApiManager = () => {
  const [isEnabled] = useFeatureToggle();

  if (isEnabled(STATSIG_FEATURE_GATES.ENABLE_GRAPHQL_CACHING)) {
    return <CacheApiCalls />;
  }

  return null;
};
